import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { Permissions } from '@app/infrastructure/permission/permission.model';
import { ISectionPage } from '@app/sidebar-layout/interfaces/i-section-page';
import { OrganizationTypes } from '@core/services/organization/organization.interface';
import { AdminPanelRoutes } from '@modules/admin-panel/admin-panel-routes';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { ServiceLinkIcons } from './sidebarIcons';

export const servicesLinks: ISectionPage[] = [
	{
		name: 'Insights',
		url: `/${AppRouteHelper.home}`,
		permissionKey: 'optimization-hub',
		iconUrl: ServiceLinkIcons.optimizationHub,
		featureFlag: FEATURE_FLAGS.ENABLE_OPTIMIZATION_HUB,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Virtual Machines',
		url: `/${AppRouteHelper.azureVm}`,
		permissionKey: 'azure-vm',
		iconUrl: ServiceLinkIcons.azureVm,
		orgCloudTypes: [OrganizationTypes.Azure],
	},
	{
		name: 'Dashboard',
		url: `/${AppRouteHelper.dashboard}`,
		permissionKey: 'dashboard',
		iconUrl: ServiceLinkIcons.servicesDashboard,
		hasSeparator: true,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Compute Explorer',
		url: `/${AppRouteHelper.computeExplorer}`,
		permissionKey: Permissions.EC2View,
		iconUrl: ServiceLinkIcons.servicesCE,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'RDS Explorer',
		url: `/${AppRouteHelper.rdsExplorer}`,
		permissionKey: Permissions.DatabaseExplorerView,
		iconUrl: ServiceLinkIcons.servicesCE,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Zesty Disk',
		url: `/${AppRouteHelper.disk}`,
		permissionKey: 'zesty-disk',
		iconUrl: ServiceLinkIcons.servicesZD,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'S3 Explorer',
		url: `/${AppRouteHelper.s3}`,
		permissionKey: 's3',
		iconUrl: ServiceLinkIcons.servicesS3,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Unused Resources',
		url: `/${AppRouteHelper.unusedResources}`,
		permissionKey: 'unused-resources',
		iconUrl: ServiceLinkIcons.servicesUR,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Kubernetes',
		url: `/${AppRouteHelper.dynamicContainers}`,
		permissionKey: 'dynamic-container',
		featureFlag: FEATURE_FLAGS.ENABLE_K8S_IN_SIDEBAR,
		iconUrl: ServiceLinkIcons.dynamicContainers,
		badge: 'Beta',
		orgCloudTypes: [OrganizationTypes.AWS],
	},
];

export const myOrganizationLinks: ISectionPage[] = [
	{
		name: 'General',
		url: `/${AppRouteHelper.myOrganization}/general`,
		permissionKey: 'my-organization__general',
		iconUrl: ServiceLinkIcons.myOrgsGeneral,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Users',
		url: `/${AppRouteHelper.myOrganization}/users`,
		permissionKey: 'my-organization__users',
		iconUrl: ServiceLinkIcons.myOrgsUsers,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Reports',
		url: `/${AppRouteHelper.myOrganization}/reports`,
		permissionKey: 'my-organization__reports',
		iconUrl: ServiceLinkIcons.myOrgReports,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Accounts',
		url: `/${AppRouteHelper.myOrganization}/accounts`,
		permissionKey: 'my-organization__accounts',
		iconUrl: ServiceLinkIcons.myOrgsAccounts,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Payment',
		url: `/${AppRouteHelper.myOrganization}/payment`,
		permissionKey: 'my-organization__billing-history',
		iconUrl: ServiceLinkIcons.myOrgPayments,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Onboarding',
		url: `/${AppRouteHelper.myOrganization}/onboarding`,
		permissionKey: 'my-organization__on-boarding',
		iconUrl: ServiceLinkIcons.myOrgOnboarding,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Access Tokens',
		url: `/${AppRouteHelper.accessTokens}`,
		permissionKey: 'dynamic-container',
		iconUrl: ServiceLinkIcons.myAccessTokens,
		featureFlag: FEATURE_FLAGS.ENABLE_CONTAINERS_POD_RECOMMENDATION,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
];

export const partnerPortalLinks: ISectionPage[] = [
	{
		name: 'Organizations',
		url: `/${AppRouteHelper.shellPartnersPrefix}/${AppRouteHelper.partnersPortalOrganizations}`,
		permissionKey: 'partner-portal__organizations',
		iconUrl: ServiceLinkIcons.controlPanelOrganizations,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Accounts',
		url: `/${AppRouteHelper.shellPartnersPrefix}/${AppRouteHelper.partnersPortalAccounts}`,
		permissionKey: 'partner-portal__accounts',
		iconUrl: ServiceLinkIcons.partnersAccounts,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'Billing History',
		url: `/${AppRouteHelper.shellPartnersPrefix}/${AppRouteHelper.partnersPortalBillings}`,
		permissionKey: 'partner-portal__billing-history',
		iconUrl: ServiceLinkIcons.partnersBilling,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'PRM',
		url: `/${AppRouteHelper.shellPartnersPrefix}/${AppRouteHelper.partnersPortalReport}`,
		permissionKey: 'partner-portal__report',
		iconUrl: ServiceLinkIcons.partnersRPM,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
];

export const controlPanelLinks: ISectionPage[] = [
	{
		name: 'Organizations',
		url: `/${AppRouteHelper.shellAdminPanelPrefix}/${AdminPanelRoutes.Organizations}`,
		permissionKey: 'admin-panel__organizations',
		iconUrl: ServiceLinkIcons.controlPanelOrganizations,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Accounts',
		url: `/${AppRouteHelper.shellAdminPanelPrefix}/${AdminPanelRoutes.Accounts}`,
		permissionKey: 'admin-panel__accounts',
		iconUrl: ServiceLinkIcons.controlPanelAccounts,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Users',
		url: `/${AppRouteHelper.shellAdminPanelPrefix}/${AdminPanelRoutes.Users}`,
		permissionKey: 'admin-panel__users',
		iconUrl: ServiceLinkIcons.controlPanelUsers,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Partners',
		url: `/${AppRouteHelper.shellAdminPanelPrefix}/${AdminPanelRoutes.Partners}`,
		permissionKey: 'admin-panel__partners',
		iconUrl: ServiceLinkIcons.controlPanelPartners,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Reports',
		url: `/${AppRouteHelper.shellAdminPanelPrefix}/${AdminPanelRoutes.Reports}`,
		permissionKey: 'admin-panel__reports',
		iconUrl: ServiceLinkIcons.controlPanelReports,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Approve Billing',
		url: `/${AppRouteHelper.shellAdminPanelPrefix}/${AdminPanelRoutes.ApproveBilling}`,
		permissionKey: Permissions.AdminPanelApproveBillingView,
		iconUrl: ServiceLinkIcons.controlPanelReports,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
	{
		name: 'Permissions',
		url: `/${AppRouteHelper.shellAdminPanelPrefix}/${AdminPanelRoutes.Permissions}`,
		permissionKey: 'admin-panel__permissions',
		iconUrl: ServiceLinkIcons.controlPanelPermissions,
		orgCloudTypes: [OrganizationTypes.AWS, OrganizationTypes.Azure],
	},
];

export const riManagerLinks: ISectionPage[] = [
	{
		name: 'RI Manager',
		url: `/${AppRouteHelper.riManager}/${AppRouteHelper.riManagerList}`,
		permissionKey: 'ri-manager',
		iconUrl: ServiceLinkIcons.riManager,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'EC2 Listing',
		url: `/${AppRouteHelper.listings}`,
		permissionKey: 'listings',
		iconUrl: ServiceLinkIcons.riEc,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
	{
		name: 'RF Visualization',
		url: `/${AppRouteHelper.rfVisualization}`,
		permissionKey: 'rfVisualization',
		iconUrl: ServiceLinkIcons.myOrgReports,
		orgCloudTypes: [OrganizationTypes.AWS],
	},
];
